/// <reference types="vite/client" />

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setRepository } from './data/repository';
import { LocalVaultRepository } from './data/localRepository';
import { PocketBaseVaultRepository } from './data/pocketbaseRepository';
import App from './App';
import './styles/app.css';

const useLocal = import.meta.env.VITE_MFV_USE_LOCAL === 'true';
const pbUrl = import.meta.env.VITE_POCKETBASE_URL;

const renderError = (msg: string) => {
  createRoot(document.getElementById('root')!).render(
    <div style={{ padding: 40, fontFamily: 'sans-serif', textAlign: 'center', backgroundColor: '#f8fafc', height: '100vh' }}>
      <h1 style={{ color: '#ef4444', fontSize: '24px', marginBottom: '16px' }}>Configuration Error</h1>
      <p style={{ color: '#64748b' }}>{msg}</p>
    </div>
  );
};

if (!useLocal && !pbUrl) {
  renderError('Missing VITE_POCKETBASE_URL environment variable. System cannot start in production mode.');
} else {
  const repo = useLocal ? new LocalVaultRepository() : new PocketBaseVaultRepository(pbUrl!);
  setRepository(repo);

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}